// Kroatische, gekürzte i-Texte (Module 04-07), erstellt 15.09.2026, gegenzulesen.
// Schluessel und Felder wie in ../pruefpunktInfoTeil2.js (INFO_TEIL2, MODUL_INFO_TEIL2).

export const MODUL_INFO_HR_TEIL2 = {
  '04-TRAFO-SICHT':
    'Vizualni pregled transformatora: zaštitne naprave, uzemljenje, zapreka, kotači i SN kabeli. Transformatoru pristupati samo u isključenom stanju.',
  '05-OEL-WANNE':
    'Pregled uljne kade ispod uljnog transformatora: stanje, nepropusnost, čistoća i dovoljan volumen. Limena kada (05.1.x) ili premazni sustav (05.2.x).',
  '05-SICHERHEITS-ZUBEHOER':
    'Provjera jesu li zaštitna oprema, pomagala, znakovi i sheme u stanici prisutni, neoštećeni i unutar roka. Očitati datume ispitivanja i proizvodnje.',
  '06-ERDERANLAGE':
    'Vizualni pregled sabirnice za izjednačenje potencijala i spojeva uzemljenja te mjerenje otpora uzemljenja. Vrijednosti u ohmima upisuju se u blok „uzemljivač".',
  '07-ELEKTROTHERMOGRAFIE':
    'Termografija dijelova postrojenja u radu radi otkrivanja zagrijavanja na spojevima, stezaljkama i kabelima. Mjeriti po mogućnosti pod opterećenjem; ETB nema fiksne granične vrijednosti.',
};

export const INFO_HR_TEIL2 = {
  // ── 04-TRAFO-SICHT ────────────────────────────────────────────
  '04-TRAFO-SICHT|04.1': {
    was: 'Postoje li i proradaju li sve zaštitne i nadzorne naprave transformatora (npr. Buchholz relej, termometar, PTC).',
    achten: [
      'Ispitati prorad (tipka/kontakt) i provjeriti signal ili isklop',
      'Očitati i zapisati maksimalnu temperaturu (vučna kazaljka)',
      'Oštećeni, odspojeni ili premošteni vodovi i kontakti',
    ],
    nio: 'neispravno ako zaštita ne proradi, premoštena je, oštećena ili ne šalje signal.',
    norm: 'DIN VDE 0105-100, podaci proizvođača transformatora',
  },
  '04-TRAFO-SICHT|04.2': {
    was: "Postoji li na SN strani (OS) transformatora mogućnost uzemljenja i kratkog spajanja, npr. kuglaste točke. Otpada ako je transformator na OS strani utaknut (vanjski konus) – tada se uzemljuje u trafo polju.",
    achten: [
      "Točke na sve tri faze i na priključku uzemljenja",
      "Čvrste, bez korozije, nisu lakirane",
      "Dostupne priborom za uzemljenje stanice",
    ],
    nio: "Neispravno ako mogućnost uzemljenja nedostaje, nepotpuna je ili neupotrebljiva. Uvijek potrebno: kod radova na transformatoru mora se uzemljiti.",
    norm: "DIN VDE 0105-100, DIN EN 61230 (VDE 0683-100)",
  },
  '04-TRAFO-SICHT|04.3': {
    was: "Postoji li na NN strani (US) transformatora mogućnost uzemljenja, npr. vijci za uzemljenje (kuglaste točke) na L1, L2, L3 i PEN.",
    achten: [
      "Vijci za uzemljenje na svim vodičima",
      "Čvrsti, čisti, nisu lakirani ni korodirani",
      "Upotrebljivi s NN priborom za uzemljenje",
      "Ako kod transformatora piše „bez vijaka za uzemljenje\", aplikacija automatski postavlja neispravno",
    ],
    nio: "Neispravno ako mogućnost uzemljenja nedostaje, nepotpuna je ili neupotrebljiva. Uvijek potrebno: kod radova na transformatoru mora se uzemljiti.",
    norm: "DIN VDE 0105-100, DIN EN 61230 (VDE 0683-100)",
  },
  '04-TRAFO-SICHT|04.12': {
    was: 'Je li zvjezdište (N-vodič) uzemljeno izravno na transformatoru.',
    achten: [
      'Potražiti spoj N-priključka transformatora na uzemljenje odnosno vodič uzemljenja',
      'da = nedostatak (crveno), ne = ispravno (zeleno) – pravilo ETB',
    ],
    nio: 'neispravno ako je zvjezdište uzemljeno na transformatoru.',
    norm: 'pravilo ETB',
  },
  '04-TRAFO-SICHT|04.4': {
    was: 'Postoji li ispred transformatora zapreka (upozoravajuća greda) protiv nenamjernog ulaska.',
    achten: [
      'Greda postavljena, ne odložena sa strane',
      'Nosači čvrsti, greda nije savijena ni slomljena',
      'Stvarno zatvara pristup (visina, širina)',
    ],
    nio: 'neispravno ako greda nedostaje, oštećena je ili ne zatvara pristup.',
    norm: 'TAB operatora mreže, VDN, propis UV (prema ETB predlošku)',
  },
  '04-TRAFO-SICHT|04.5': {
    was: 'Je li zapreka označena crno-žutom upozoravajućom trakom.',
    achten: [
      'Traka postoji i dobro je vidljiva',
      'Nije izblijedjela, odlijepljena ni zaprljana',
    ],
    nio: 'neispravno ako traka nedostaje, jako je izblijedjela ili odlijepljena.',
    norm: 'propis UV (prema ETB predlošku)',
  },
  '04-TRAFO-SICHT|04.6': {
    was: 'Je li na zapreci trokutasti žuto-crni znak upozorenja „Visoki napon – opasnost po život" sa simbolom munje.',
    achten: [
      'Znak postoji, čitljiv i čvrsto pričvršćen',
      'Ispravan simbol (W012)',
      'Nije izblijedio, izgreban ni prekriven',
    ],
    nio: 'neispravno ako znak nedostaje, nečitljiv je ili nije propisani simbol.',
    norm: 'ASR A1.3, DIN EN ISO 7010 (W012)',
  },
  '04-TRAFO-SICHT|04.7': {
    was: "Samo kod transformatora s lijevanom smolom: je li postavljena pločica upozorenja „Kućište je pod naponom!\". Kod uljnog transformatora pitanje se ne pojavljuje.",
    achten: [
      "Pločica postoji, čitljiva, čvrsto postavljena",
      "Dobro vidljiva kod pristupa transformatoru",
    ],
    nio: "Neispravno ako pločica nedostaje, nečitljiva je ili oštećena.",
    norm: "UV propis (prema ETB predlošku)",
  },
  '04-TRAFO-SICHT|04.8': {
    was: "Je li transformator osiguran od kotrljanja: blokade kotača ILI prigušivači vibracija.",
    achten: [
      "Blokade na svim kotačima, čvrste",
      "Prigušivači vibracija umjesto blokada: odabrati ispravno i upisati u napomenu",
      "Transformator se ne može pomaknuti",
    ],
    nio: "Neispravno ako nema ni blokada ni prigušivača ili je osiguranje labavo.",
    norm: "DIN VDE 0105-100, procjena rizika prema ArbSchG, DGUV propis 1",
  },
  '04-TRAFO-SICHT|04.9': {
    was: 'Je li zaslon kabela SN kabela uzemljen obostrano (na transformatoru i u rasklopnom postrojenju SN).',
    achten: [
      'Zaslon na kabelskoj glavi transformatora spojen sa zemljom',
      'Zaslon na kraju kabela u SN postrojenju također uzemljen',
      'Vodovi uzemljenja čvrsti, bez prekida i korozije',
    ],
    nio: 'neispravno ako je zaslon kabela uzemljen samo jednostrano ili nije uzemljen.',
    norm: 'zahtjev ETB / operatora mreže (normu dopunjuje ured)',
  },
  '04-TRAFO-SICHT|04.10': {
    was: "Samo kod operatora mreže Netze BW / EnBW: je li iznad transformatora postavljena sabirnica za uzemljenje.",
    achten: [
      "Sabirnica iznad transformatora postoji",
      "Kod „da\" slijedi pitanje o stanju (izolacijski nosači, pričvršćenje)",
    ],
    nio: "„ne\" je nedostatak – Netze BW zahtijeva sabirnicu.",
    norm: "Zahtjev Netze BW / EnBW",
  },
  '04-TRAFO-SICHT|04.11': {
    was: "Stanje sabirnice za uzemljenje iznad transformatora.",
    achten: [
      "Izolacijski nosači postoje i neoštećeni",
      "Sabirnica čvrsto montirana, bez korozije",
    ],
    nio: "Neispravno ako izolacijski nosači nedostaju ili su oštećeni, sabirnica labava ili korodirana – dodirni razlog.",
    norm: "Zahtjev Netze BW / EnBW",
  },

  // ── 05-OEL-WANNE ──────────────────────────────────────────────
  '05-OEL-WANNE|05.1': {
    was: 'Postoji li ispod uljnog transformatora uljna kada (limena kada ili premazni sustav).',
    achten: [
      'Suhi transformator (lijevana smola, GH) ne treba kadu',
      'Kada mora obuhvatiti cijeli transformator',
      'Kod „ne" nastaviti s točkom 6',
    ],
    nio: 'Odabrati „ne" ako ispod uljnog transformatora nema ni limene kade ni premaznog sustava.',
    norm: 'AwSV, TRwS 779, DIN EN 61936-1 (VDE 0101-1)',
  },
  '05-OEL-WANNE|05.1.1': {
    was: "Kako je izvedena uljna kada? Kada od lima, plastike ili drugog materijala – ili gotova stanica s premazom.",
    achten: [
      "Kada: zatim pitanja o kadi i gore izmjeriti dimenzije (sve u metrima)",
      "Premaz: bez mjerenja, zapremina se smatra ispravnom",
      "Drugi materijal: upisati kod „Dodatni podaci\"",
    ],
    nio: "Nema ispravno/neispravno – samo odabrati izvedbu. Ako kade nema, nedostatak je 05.1 „ne\".",
    norm: "AwSV, TRwS 779",
  },
  '05-OEL-WANNE|05.1.2': {
    was: 'Vizualni pregled limene kade na koroziju, pukotine i deformacije.',
    achten: [
      'Hrđa, osobito prohrđalost dna i kutova',
      'Pukotine, udubljenja, deformacije',
      'Oštećena antikorozivna zaštita',
    ],
    nio: 'neispravno ako korozija, pukotine ili deformacije ugrožavaju nepropusnost ili nosivost.',
    norm: 'AwSV, TRwS 779',
  },
  '05-OEL-WANNE|05.1.3': {
    was: 'Provjera nepropusnosti zavara i prijelaza limene kade.',
    achten: [
      'Pukotine ili pore u zavarima',
      'Tragovi ulja ili vlage izvan ili ispod kade',
      'Propusni prolazi ili priključci',
    ],
    nio: 'neispravno ako zavar ili prijelaz propušta ili pokazuje znakove propuštanja.',
    norm: 'AwSV, TRwS 779',
  },
  '05-OEL-WANNE|05.1.4': {
    was: 'Ima li u limenoj kadi vode, ulja ili prljavštine.',
    achten: [
      'Stajaća voda (kondenzat, krov, podzemna voda)',
      'Ostaci ulja kao znak curenja transformatora',
      'Lišće, prljavština, ostaci životinja',
    ],
    nio: 'neispravno ako u kadi ima vode, ulja ili prljavštine.',
    norm: 'AwSV, TRwS 779',
  },
  '05-OEL-WANNE|05.1.5': {
    was: 'Je li volumen limene kade barem jednak količini ulja transformatora (natpisna pločica).',
    achten: [
      'Količinu ulja očitati s natpisne pločice (kg ili l)',
      'Usporediti s volumenom kade iz obrasca stanice',
      'Više transformatora na jednoj kadi: zbrojiti količine',
    ],
    nio: 'neispravno ako je volumen kade manji od količine ulja.',
    norm: 'AwSV, TRwS 779, DIN EN 61936-1 (VDE 0101-1)',
  },
  '05-OEL-WANNE|05.1.6': {
    was: 'Smanjuju li predmeti u limenoj kadi njezin volumen.',
    achten: [
      'Odloženi predmeti, materijal, ostaci kabela',
      'Ugradnje (podlošci, kamenje) koje zauzimaju volumen',
    ],
    nio: 'neispravno ako strani predmeti u kadi smanjuju volumen.',
    norm: 'AwSV, TRwS 779',
  },
  '05-OEL-WANNE|05.1.7': {
    was: 'Je li limena kada spojena na uzemljivač.',
    achten: [
      'Vod uzemljenja na kadi postoji i čvrst je',
      'Spojno mjesto bez korozije i boje',
      'Spoj na sabirnicu za izjednačenje potencijala vidljiv',
    ],
    nio: 'neispravno ako spoj uzemljenja nedostaje, labav je ili jako korodiran.',
    norm: 'DIN EN 61936-1 (VDE 0101-1)',
  },
  '05-OEL-WANNE|05.2.1': {
    was: 'Je li uljna kada izvedena kao premazni sustav (npr. betonska kada s uljnonepropusnim premazom).',
    achten: [
      'Premaz vidljiv na podu i zidovima trafo-komore',
      'Kod limene kade jednostavno odabrati „ne"',
    ],
    nio: '„ne" nije nedostatak – tada je kada izvedena kao limena kada. Ako nema ni limene kade ni premaza, nedostatak je 05.1 „ne".',
    norm: 'AwSV, TRwS 779',
  },
  '05-OEL-WANNE|05.2.2': {
    was: 'Vizualni pregled premaza na pukotine, otpadanje i mjehuriće.',
    achten: [
      'Pukotine u betonu koje prolaze kroz premaz',
      'Otpali premaz, goli beton',
      'Mjehurići ili odvajanje (vlaga ispod)',
    ],
    nio: 'neispravno ako pukotine, otpadanje ili mjehurići ugrožavaju nepropusnost.',
    norm: 'AwSV, TRwS 779',
  },
  '05-OEL-WANNE|05.2.3': {
    was: 'Provjera premaza na mehanička oštećenja i trošenje.',
    achten: [
      'Ogrebotine i udarci, npr. od ugradnje transformatora',
      'Trošenje na mjestima kotača ili nogu',
      'Probijen premaz',
    ],
    nio: 'neispravno ako oštećenja ili trošenje probijaju ili slabe premaz.',
    norm: 'AwSV, TRwS 779',
  },
  '05-OEL-WANNE|05.2.4': {
    was: 'Ima li u premazanoj kadi vode, ulja ili prljavštine.',
    achten: [
      'Stajaća voda (kondenzat, krov, podzemna voda)',
      'Ostaci ulja kao znak curenja transformatora',
      'Lišće, prljavština, ostaci životinja',
    ],
    nio: 'neispravno ako u kadi ima vode, ulja ili prljavštine.',
    norm: 'AwSV, TRwS 779',
  },
  '05-OEL-WANNE|05.2.5': {
    was: 'Je li volumen premazane kade barem jednak količini ulja transformatora (natpisna pločica).',
    achten: [
      'Količinu ulja očitati s natpisne pločice (kg ili l)',
      'Usporediti s volumenom iz obrasca stanice',
      'Pragovi na vratima ubrajaju se u visinu kade',
    ],
    nio: 'neispravno ako je volumen kade manji od količine ulja.',
    norm: 'AwSV, TRwS 779, DIN EN 61936-1 (VDE 0101-1)',
  },
  '05-OEL-WANNE|05.2.6': {
    was: 'Smanjuju li predmeti u premazanoj kadi njezin volumen.',
    achten: [
      'Odloženi predmeti, materijal, ostaci kabela',
      'Naknadne ugradnje koje zauzimaju volumen',
    ],
    nio: 'neispravno ako strani predmeti u kadi smanjuju volumen.',
    norm: 'AwSV, TRwS 779',
  },
  '05-OEL-WANNE|05.2.7': {
    was: 'Provjera premaza na prijelazima prema zidovima, kutovima i prolazima.',
    achten: [
      'Odvajanje ili pukotine na spoju poda i zida',
      'Prolazi kabela i cijevi nepropusno uklopljeni',
      'Premaz do potrebne visine',
    ],
    nio: 'neispravno ako premaz na zidovima ili prolazima propušta, puknut je ili odvojen.',
    norm: 'AwSV, TRwS 779',
  },

  // ── 05-SICHERHEITS-ZUBEHOER ───────────────────────────────────
  '05-SICHERHEITS-ZUBEHOER|05': {
    was: 'Postoji li ispravna ručka za NH osigurače (sa štitnikom podlaktice) za vađenje i umetanje osigurača.',
    achten: [
      'Izolacija bez pukotina i tragova gorenja',
      'Zabravljivanje sigurno uskače',
      'Štitnik podlaktice postoji i neoštećen je',
    ],
    nio: 'neispravno ako je ručka oštećena, ne zabravljuje sigurno ili nedostaje štitnik.',
    norm: 'DIN VDE 0680 dio 4',
  },
  '05-SICHERHEITS-ZUBEHOER|05.1': {
    was: 'Postoji li električno izolacijska zaštitna kaciga i je li još upotrebljiva.',
    achten: [
      'Oznaka za izolacijske kacige (EN 50365)',
      'Istekao rok uporabe prema proizvođaču → „zastarjelo"',
      'Pukotine, promjena boje, krhka ljuska',
    ],
    nio: 'neispravno ako je kaciga oštećena, bez oznake ili joj je istekao rok.',
    norm: 'DIN EN 50365',
  },
  '05-SICHERHEITS-ZUBEHOER|05.2': {
    was: 'Postoji li ispravan štitnik za lice (zaštita od električnog luka) za kacigu.',
    achten: [
      'Štitnik odgovara postojećoj kacigi',
      'Vizir čist, bez ogrebotina i pukotina',
      'Provjeriti oznaku i datum; istekao → „zastarjelo"',
    ],
    nio: 'neispravno ako štitnik nedostaje, oštećen je, ne odgovara kacigi ili je istekao.',
    norm: 'DIN EN 166, GS-ET 29',
  },
  '05-SICHERHEITS-ZUBEHOER|05.3': {
    was: 'Postoji li torba za čuvanje zaštitne opreme (kaciga, štitnik).',
    achten: [
      'Torba postoji, čista i neoštećena',
      'Oprema je stvarno spremljena u njoj',
    ],
    nio: 'neispravno ako torba nedostaje ili više ne štiti opremu.',
    norm: 'podaci proizvođača zaštitne opreme',
  },
  '05-SICHERHEITS-ZUBEHOER|05.4': {
    was: 'Postoje li izolacijske zaštitne rukavice do 1000 V, neoštećene i unutar roka ispitivanja.',
    achten: [
      'Klasa i oznaka (dvostruki trokut) na rukavici',
      'Očitati datum ispitivanja; prekoračen → „zastarjelo"',
      'Pukotine, rupe, porozna mjesta (proba napuhavanjem)',
    ],
    nio: 'neispravno ako su rukavice oštećene, bez oznake ili je rok ispitivanja prekoračen.',
    norm: 'DIN VDE 0682 dio 311 (EN 60903)',
  },
  '05-SICHERHEITS-ZUBEHOER|05.5': {
    was: 'Postoji li torba za čuvanje izolacijskih rukavica.',
    achten: [
      'Torba postoji, rukavice su u njoj',
      'Rukavice nisu presavijene ni zgnječene',
      'Zaštićene od svjetla, topline i prljavštine',
    ],
    nio: 'neispravno ako torba nedostaje ili rukavice stoje nezaštićene.',
    norm: 'DIN VDE 0682 dio 311 (EN 60903)',
  },
  '05-SICHERHEITS-ZUBEHOER|05.6': {
    was: 'Postoji li pneumatski ispitivač rukavica za provjeru nepropusnosti prije uporabe.',
    achten: [
      'Uređaj radi i drži tlak',
      'Odgovara postojećim rukavicama',
      'Bez pukotina na mijehu i stezaljki',
    ],
    nio: 'neispravno ako je ispitivač neispravan, ne odgovara ili ne drži zrak.',
    norm: 'DIN VDE 0682 dio 311 (EN 60903)',
  },
  '05-SICHERHEITS-ZUBEHOER|05.34': {
    was: "Postoji li izolacijska spasilačka motka za izvlačenje unesrećene osobe iz opasnog područja (spašavanje kod električne nesreće).",
    achten: [
      "Motka postoji, čista i suha, izolacijski dio bez pukotina",
      "Naljepnica ispitivanja / zadnje ispitivanje (godišnje, orijentacijski)",
      "Graničnik rukohvata vidljiv",
    ],
    nio: "Neispravno ako motka nedostaje, oštećena je ili je rok ispitivanja prekoračen.",
    norm: "DIN EN IEC 61235 (VDE 0681-1); ETB brošura 15",
  },
  '05-SICHERHEITS-ZUBEHOER|05.7': {
    was: 'Postoji li neoštećen gumeni izolacijski tepih (1 m × 1 m) ispred NN postrojenja.',
    achten: [
      'Tepih leži na mjestu posluživanja',
      'Bez pukotina, rupa i krhkih mjesta',
      'Oznaka (naponska klasa) čitljiva',
    ],
    nio: 'neispravno ako je tepih oštećen, krhak ili premalen.',
    norm: 'DIN VDE 0680 dio 1',
  },
  '05-SICHERHEITS-ZUBEHOER|05.8': {
    was: 'Postoji li ispravan dvopolni ispitivač napona za 230/400 V.',
    achten: [
      'Samotest ili provjera na poznatom izvoru prije uporabe',
      'Vrhovi sa zaštitom od dodira, vod neoštećen',
      'Baterija u redu, prikaz čitljiv',
    ],
    nio: 'neispravno ako je ispitivač oštećen, pogrešno pokazuje ili ne prođe provjeru.',
    norm: 'DIN VDE 0682-401 / EN 61243-3',
  },
  '05-SICHERHEITS-ZUBEHOER|05.9': {
    was: "Jesu li propisane pločice upozorenja i obavijesti potpune, čitljive i čvrsto postavljene.",
    achten: [
      "Po SN/NN prostoriji 4 pločice: VDE, prva pomoć, gašenje požara, 5 sigurnosnih pravila",
      "Od 2 prstenasta kabelska polja po polju „Oprez povratni napon\"",
      "Po SN polju „Ne uključivati\" i „Oprez uzemljeno i kratko spojeno\"",
      "Potrebni broj predlaže aplikacija – upiši stvarni, ona sama ocjenjuje",
    ],
    nio: "Neispravno ako ima manje pločica nego što je potrebno ili su nečitljive.",
    norm: "DIN VDE 0105-100, DIN EN ISO 7010, DGUV Vorschrift 1 i 3, DGUV Regel 103-011",
  },
  '05-SICHERHEITS-ZUBEHOER|05.10': {
    was: 'Postoji li ispravna motka za uzemljenje (za postavljanje naprave za uzemljenje i kratko spajanje (EuK)).',
    achten: [
      'Izolacijska cijev bez pukotina, zareza i prljavštine',
      'Graničnik ruke (štitnik) postoji',
      'Glava odgovara stezaljkama uzemljenja stanice',
    ],
    nio: 'neispravno ako je motka oštećena, ne odgovara garnituri ili je zastarjela.',
    norm: 'DIN EN 61235 (prema ETB predlošku)',
  },
  '05-SICHERHEITS-ZUBEHOER|05.11': {
    was: 'Postoji li neoštećena naprava za uzemljenje i kratko spajanje (EuK) prikladna za stanicu.',
    achten: [
      'Užad bez prekida žica, plašt neoštećen',
      'Stezaljke čvrsto prešane, navoji ispravni',
      'Presjek odgovara struji kratkog spoja postrojenja',
    ],
    nio: 'neispravno ako je garnitura oštećena, ne odgovara točkama ili je premalog presjeka.',
    norm: 'DIN VDE 0683-100 (EN/IEC 61230)',
  },
  '05-SICHERHEITS-ZUBEHOER|05.12': {
    was: 'Postoji li zidni nosač za garnituru za uzemljenje i motku za uzemljenje.',
    achten: [
      'Nosač čvrsto montiran',
      'Garnitura i motka uredno i zaštićeno obješene',
    ],
    nio: 'neispravno ako nosač nedostaje, labav je ili ne može primiti opremu.',
    norm: 'podaci proizvođača',
  },
  '05-SICHERHEITS-ZUBEHOER|05.13': {
    was: 'Postoje li ispravna kliješta za VN osigurače za zamjenu SN osigurača.',
    achten: [
      'Odgovaraju ugrađenim VN visokoučinskim osiguračima (HH)',
      'Izolacijski dio bez pukotina, mehanika ispravna',
      'Vrlo star model ili zastarjela norma → „zastarjelo"',
    ],
    nio: 'neispravno ako su kliješta oštećena, ne odgovaraju ili ne hvataju sigurno.',
    norm: 'DIN VDE 0681-3',
  },
  '05-SICHERHEITS-ZUBEHOER|05.14': {
    was: 'Postoji li nosač za čuvanje VN visokoučinskih osigurača (HH), npr. rezervnih.',
    achten: [
      'Nosač čvrsto montiran',
      'Osigurači zaštićeni, ne leže na podu',
    ],
    nio: 'neispravno ako nosač nedostaje ili je oštećen.',
    norm: 'podaci proizvođača',
  },
  '05-SICHERHEITS-ZUBEHOER|05.15': {
    was: 'Postoji li nosač za kliješta za VN osigurače.',
    achten: [
      'Nosač čvrsto montiran',
      'Kliješta zaštićena i nadohvat ruke',
    ],
    nio: 'neispravno ako nosač nedostaje ili je oštećen.',
    norm: 'podaci proizvođača',
  },
  '05-SICHERHEITS-ZUBEHOER|05.16': {
    was: 'Jesu li u SN postrojenju ugrađeni ispravni VN visokoučinski osigurači (HH); zapisati nazivnu struju i napon.',
    achten: [
      'Nazivna struja odgovara snazi transformatora (tablica proizvođača)',
      'Nazivni napon odgovara naponu mreže',
      'Sve tri faze jednake, udarna igla nije izbačena',
    ],
    nio: 'neispravno ako je veličina pogrešna ili su osigurači različiti ili oštećeni.',
    norm: 'DIN 43625',
  },
  '05-SICHERHEITS-ZUBEHOER|05.17': {
    was: 'Postoje li odgovarajući rezervni VN visokoučinski osigurači (HH); zapisati nazivnu struju i napon.',
    achten: [
      'Iste vrijednosti kao ugrađeni osigurači',
      'Uobičajen je puni komplet (tri komada)',
      'Neoštećeni i suho spremljeni',
    ],
    nio: 'neispravno ako rezervni osigurači nedostaju, pogrešne su veličine ili oštećeni.',
    norm: 'DIN 43625',
  },
  '05-SICHERHEITS-ZUBEHOER|05.18': {
    was: 'Postoji li ispravan ispitivač napona za srednji napon (SN) prikladan za napon mreže.',
    achten: [
      'Nazivno područje napona odgovara postrojenju',
      'Samotest postoji i uspješan je',
      'Izolacijski dio neoštećen; paziti na datum ispitivanja',
    ],
    nio: 'neispravno ako ispitivač ne odgovara naponu, oštećen je, ne prođe samotest ili je zastario.',
    norm: 'DIN VDE 0682 dio 411 (EN/IEC 61243-1)',
  },
  '05-SICHERHEITS-ZUBEHOER|05.19': {
    was: 'Postoje li nosači za SN ispitivače napona; upisati potreban i stvaran broj.',
    achten: [
      'Broj nosača odgovara broju ispitivača',
      'Nosači čvrsti, ispitivači zaštićeni',
    ],
    nio: 'neispravno ako nosači nedostaju, labavi su ili ih je premalo.',
    norm: 'podaci proizvođača',
  },
  '05-SICHERHEITS-ZUBEHOER|05.20': {
    was: 'Postoji li neoštećena sklopna motka (izolacijska motka) za posluživanje SN postrojenja.',
    achten: [
      'Izolacijska cijev bez pukotina, zareza i prljavštine',
      'Duljina i glava odgovaraju postrojenju',
      'Graničnik ruke postoji',
    ],
    nio: 'neispravno ako je motka oštećena, ne odgovara ili je zastarjela.',
    norm: 'E DIN VDE V 0681-1 i -2 (prema ETB predlošku)',
  },
  '05-SICHERHEITS-ZUBEHOER|05.21': {
    was: 'Postoje li nosači za sklopne motke; upisati potreban i stvaran broj.',
    achten: [
      'Broj nosača odgovara broju motki',
      'Nosači čvrsti, motka zaštićeno obješena',
    ],
    nio: 'neispravno ako nosači nedostaju, labavi su ili ih je premalo.',
    norm: 'podaci proizvođača',
  },
  '05-SICHERHEITS-ZUBEHOER|05.22': {
    was: 'Postoje li na VN strani transformatora kuglaste točke za uzemljenje za postavljanje garniture.',
    achten: [
      'Točke na sve tri faze',
      'Čvrsto pritegnute, bez korozije i boje',
      'Kod oklopljenih utikača točke možda nisu moguće → posebna opcija',
    ],
    nio: 'neispravno ako točke nedostaju, oštećene su ili neupotrebljive s garniturom.',
    norm: 'DIN VDE 0683-100 (EN/IEC 61230), prema DIN 48088-1',
  },
  '05-SICHERHEITS-ZUBEHOER|05.23': {
    was: 'Postoje li na NN strani transformatora kuglaste točke za uzemljenje za postavljanje garniture.',
    achten: [
      'Točke na L1, L2, L3 i PEN/N',
      'Čvrsto pritegnute, bez korozije i boje',
      'Kod oklopljenih priključaka odabrati posebnu opciju',
    ],
    nio: 'neispravno ako točke nedostaju, oštećene su ili neupotrebljive s garniturom.',
    norm: 'DIN VDE 0683-100 (EN/IEC 61230), prema DIN 48088-1',
  },
  '05-SICHERHEITS-ZUBEHOER|05.24': {
    was: 'Postoji li ispravan pokazivač napona za kapacitivni HR sustav SN postrojenja.',
    achten: [
      'Uređaj odgovara sustavu postrojenja (HR, LRM itd.)',
      'Samotest ili provjera sučelja uspješna',
      'Kućište i utikač neoštećeni',
    ],
    nio: 'neispravno ako uređaj nedostaje, ne odgovara sustavu, neispravan je ili zastario.',
    norm: 'DIN VDE 0682-415 (EN/IEC 61243-5)',
  },
  '05-SICHERHEITS-ZUBEHOER|05.25': {
    was: "Postoji li u stanici aktualna pregledna shema SN postrojenja.",
    achten: [
      "Shema postoji, čitljiva i aktualna",
      "Kombinirana shema (SN i NN zajedno) također je ispravna → „ispravno – kombinirana shema\"",
    ],
    nio: "Neispravno ako shema ne postoji ili je zastarjela.",
    norm: "TAB operatora mreže, VDN (prema ETB predlošku)",
  },
  '05-SICHERHEITS-ZUBEHOER|05.26': {
    was: "Postoji li u stanici aktualna pregledna shema NN postrojenja.",
    achten: [
      "Shema postoji, čitljiva i aktualna",
      "Kombinirana shema (SN i NN zajedno) također je ispravna → „ispravno – kombinirana shema\"",
    ],
    nio: "Neispravno ako shema ne postoji ili je zastarjela.",
    norm: "TAB operatora mreže, VDN (prema ETB predlošku)",
  },
  '05-SICHERHEITS-ZUBEHOER|05.27': {
    was: 'Postoji li spreman akumulatorski ručni reflektor za rad pri nestanku struje.',
    achten: [
      'Uključiti i provjeriti jačinu svjetla',
      'Baterija napunjena, punjač priključen (ako je predviđen)',
      'Kućište neoštećeno',
    ],
    nio: 'neispravno ako reflektor ne svijetli, baterija je prazna/neispravna ili je oštećen.',
    norm: 'TAB operatora mreže, VDN, propis UV (prema ETB predlošku)',
  },
  '05-SICHERHEITS-ZUBEHOER|05.28': {
    was: 'Izolacijski tepih za rasklopne i ispitne prostorije; upisati samo broj i veličinu (m).',
    achten: [
      'Prebrojiti tepihe',
      'Zapisati duljinu i širinu u metrima',
      'Krhke ili oštećene tepihe dodatno navesti',
    ],
    nio: 'neispravno ako potrebni tepisi nedostaju ili su krhki ili oštećeni.',
    norm: 'DIN VDE 0303 dio 2 (prema ETB predlošku)',
  },
  '05-SICHERHEITS-ZUBEHOER|05.29': {
    was: 'Postoje li izolacijske zaštitne ploče za pokrivanje susjednih dijelova pod naponom; upisati mjere (V, Š, debljina) i godinu proizvodnje.',
    achten: [
      'Ploče bez pukotina, lomova, tragova gorenja i prljavštine',
      'Veličina odgovara postrojenju',
      'Očitati godinu proizvodnje i oznaku',
    ],
    nio: 'neispravno ako su ploče oštećene, ne odgovaraju postrojenju ili su zastarjele.',
    norm: 'DIN VDE 0682-552',
  },
  '05-SICHERHEITS-ZUBEHOER|05.30': {
    was: 'Postoji li u stanici CO2 aparat za gašenje požara.',
    achten: [
      'Aparat obješen nadohvat ruke kod ulaza',
      'Bez oštećenja, korozije, plomba postoji',
      'Nosač čvrst',
    ],
    nio: 'neispravno ako aparat nedostaje, oštećen je ili nije nadohvat ruke.',
    norm: 'DIN EN 3 odn. DIN 14406, DIN VDE 0105-100',
  },
  '05-SICHERHEITS-ZUBEHOER|05.31': {
    was: "Je li poštovan rok ispitivanja aparata za gašenje (svake 2 godine). Aplikacija sama ocjenjuje prema „Zadnje ispitivanje\" kod 05.30 – računato od mjeseca do mjeseca.",
    achten: [
      "Upiši datum zadnjeg ispitivanja kod 05.30 (mjesec i godina su dovoljni)",
      "Više od 24 mjeseca → neispravno; sljedeći rok stoji u napomeni",
    ],
    nio: "Neispravno ako je zadnje ispitivanje starije od 2 godine.",
    norm: "ASR A2.2, DIN 14406-4",
  },
  '05-SICHERHEITS-ZUBEHOER|05.32': {
    was: 'Jesu li sva oprema i dijelovi postrojenja (polja, transformatori, izvodi, razdjelnici) jasno i trajno označeni.',
    achten: [
      'Oznake postoje, čitljive i trajne',
      'Odgovaraju preglednoj shemi',
      'Označeni i izvodi i kabeli u glavnom NN razdjelniku (NSHV)',
    ],
    nio: 'neispravno ako oznake nedostaju, nečitljive su, nepotpune ili pogrešne.',
    norm: 'DIN VDE 0105-100',
  },
  '05-SICHERHEITS-ZUBEHOER|05.33': {
    was: 'Može li se pri posluživanju (sklapanje, zamjena osigurača) dodirnuti dio pod naponom.',
    achten: [
      'Pokrovi i zaštita od dodira potpuno montirani',
      'Nema otvorenih stezaljki ili sabirnica u zoni posluživanja',
      'Nedostaju slijepi pokrovi u razdjelnicima',
    ],
    nio: 'neispravno ako su u zoni posluživanja dostupni dijelovi pod naponom bez zaštite od dodira.',
    norm: 'DGUV Vorschrift 3, DIN VDE 0106-100',
  },

  // ── 06-ERDERANLAGE ────────────────────────────────────────────
  '06-ERDERANLAGE|06': {
    was: 'Postoji li glavna sabirnica za izjednačenje potencijala na kojoj su spojeni uzemljivač, PEN/PE i svi dijelovi za uzemljenje.',
    achten: [
      'Sabirnica čvrsto montirana, bez korozije',
      'Sve stezaljke čvrsto pritegnute',
      'Više vodiča nego stezaljki, dvostruko zauzeto → „prebukirano"',
    ],
    nio: 'neispravno ako sabirnica nedostaje, spojevi su labavi/korodirani ili su stezaljke višestruko zauzete.',
    norm: 'DIN VDE 0100 dio 410 i dio 540',
  },
  '06-ERDERANLAGE|06.1': {
    was: 'Jesu li priključci na glavnoj sabirnici za izjednačenje potencijala označeni (koji vodič kamo ide).',
    achten: [
      'Svaki priključak trajno označen',
      'Oznake odgovaraju stvarnim vodičima',
      'Uzemljivač jasno prepoznatljiv (važno za mjerenje)',
    ],
    nio: 'neispravno ako oznake nedostaju, nečitljive su, pogrešne ili nepotpune.',
    norm: 'DIN VDE 0100 dio 540',
  },
  '06-ERDERANLAGE|06.2': {
    was: 'Jesu li svi metalni dijelovi i oprema stanice (kućišta, transformator, kada, vrata, konstrukcije, zasloni kabela) uzemljeni.',
    achten: [
      'Vodovi uzemljenja na transformatoru, SN postrojenju, NSHV, uljnoj kadi, vratima',
      'Spojevi čvrsti, bez korozije i prekida',
      'Presjek nije očito premalen',
    ],
    nio: 'neispravno ako dio nije uzemljen ili je spoj labav, prekinut ili jako korodiran.',
    norm: 'DIN VDE 0100 dio 200',
  },
  '06-ERDERANLAGE|06.4': {
    was: 'Ima li svaki dio opreme vlastiti vodič uzemljenja izravno do sabirnice za uzemljenje / izjednačenje potencijala (zvjezdasto) – umjesto da je provučen od dijela do dijela.',
    achten: [
      'Transformator, uljna kada, SN postrojenje, NN razdjelnik, kućišta i vrata – svaki vlastitim vodom na sabirnicu',
      'Tipična greška: uljna kada spojena na transformator, a samo transformator na sabirnicu',
      'Ako se provučeni dio odspoji (npr. zamjena transformatora), sve iza njega ostaje neuzemljeno',
    ],
    nio: 'neispravno ako je neki dio uzemljen samo preko drugog dijela ili vodič uzemljenja nedostaje – odaberite razlog.',
    norm: 'DIN EN 50522 (VDE 0101-2), DIN VDE 0100-540 (zaštitni vodič / vodič uzemljenja ne provlačiti)',
  },
  '06-ERDERANLAGE|06.3': {
    was: 'Mjerenje otpora spojeva uzemljenja na sabirnici; vrijednosti u blok „uzemljivač", iznad 2 Ω aplikacija automatski upisuje neispravno.',
    achten: [
      'Granica: standardno ≤ 2,0 Ω (ako je za stanicu upisana druga vrijednost, npr. Hamburg 1 Ω, vrijedi ona); „OL" = izvan mjernog područja = nema spoja = nedostatak',
      'Mjerne vodove prije kratko spojiti i izjednačiti',
      'Vrijednosti upisivati sa zarezom, npr. 0,35',
    ],
    nio: 'neispravno ako je vrijednost iznad 2,0 Ω ili uređaj pokazuje „OL".',
    norm: 'granična vrijednost prema ETB predlošku (≤ 2,0 Ω)',
  },

  // ── 07-ELEKTROTHERMOGRAFIE ────────────────────────────────────
  '07-ELEKTROTHERMOGRAFIE|07': {
    was: 'Termografija glavnog NN razdjelnika (NSHV) u radu: sabirnice, osigurači, sklopke i stezaljke.',
    achten: [
      'Pojedine faze ili stezaljke znatno toplije od usporedivih',
      'Vrući NH osigurači ili letve (loš kontakt)',
      'Mjeriti pod opterećenjem; zapisati opterećenje i temperaturu okoline',
    ],
    nio: 'neispravno ako je utvrđeno upadljivo zagrijavanje koje zahtijeva provjeru ili popravak.',
    norm: 'DIN 54191',
  },
  '07-ELEKTROTHERMOGRAFIE|07.1': {
    was: 'Termografija SN rasklopnog postrojenja u radu, koliko je vidljivo izvana (kabelski prostor, kontrolno okno).',
    achten: [
      'Topla mjesta na kabelskim priključcima ili osiguračima',
      'Usporedba faza: jedna toplija od ostalih',
      'Ne otvarati pokrove pod naponom – mjeriti samo dostupno',
    ],
    nio: 'neispravno ako je utvrđeno upadljivo zagrijavanje koje zahtijeva provjeru ili popravak.',
    norm: 'DIN 54191',
  },
  '07-ELEKTROTHERMOGRAFIE|07.2': {
    was: 'Termografija transformatora u radu: priključci VN/NN strane, kotao odn. namoti, rashladna rebra.',
    achten: [
      'Topli priključni svornjaci ili stezaljke na VN ili NN strani',
      'Neravnomjerno zagrijavanje kotla ili rebara',
      'Mjeriti samo izvan zapreke',
    ],
    nio: 'neispravno ako je utvrđeno upadljivo zagrijavanje koje zahtijeva provjeru ili popravak.',
    norm: 'DIN 54191',
  },
  '07-ELEKTROTHERMOGRAFIE|07.3': {
    was: 'Termografija NN kabela i priključaka, npr. spoj transformator–NSHV i izvodi.',
    achten: [
      'Tople kabelske stopice ili stezaljke',
      'Pojedini paralelni kabel znatno topliji (nejednaka raspodjela struje)',
      'Jako zagrijani kabeli u snopovima ili uskim mjestima',
    ],
    nio: 'neispravno ako je utvrđeno upadljivo zagrijavanje koje zahtijeva provjeru ili popravak.',
    norm: 'DIN 54191',
  },
  '07-ELEKTROTHERMOGRAFIE|07.4': {
    was: 'Termografija SN kabela s kabelskim glavama odn. utikačima, koliko je vidljivo.',
    achten: [
      'Tople kabelske glave ili utikači',
      'Usporedba triju kabela',
      'Topli priključci zaslona kabela',
    ],
    nio: 'neispravno ako je utvrđeno upadljivo zagrijavanje koje zahtijeva provjeru ili popravak.',
    norm: 'DIN 54191',
  },
};
